import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f00b27ce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00b27ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f00b27ce')) {
      api.createRecord('f00b27ce', component.options)
    } else {
      api.reload('f00b27ce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f00b27ce&scoped=true", function () {
      api.rerender('f00b27ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/shoppingCredit/settings/index.vue"
export default component.exports